import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { beneficiaryApi } from "./beneficiaryApiSlice";
import beneficiaryReducer from "./beneficiarySlice";
import brandingReducer from "./brandingSlice";
import { employeeContributionApi } from "./employeeApiSlice";
import { legalDocumentsApi } from "./legalDocumentsApiSlice";
import userSlice from "./userSlice";
import wizardReducer from "./wizard";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user", "wizard"],
  blacklist: [
    beneficiaryApi.reducerPath,
    employeeContributionApi.reducerPath,
    legalDocumentsApi.reducerPath,
  ],
};
persistReducer;

const reducers = combineReducers({
  user: userSlice,
  wizard: wizardReducer,
  beneficiary: beneficiaryReducer,
  branding: brandingReducer,
  [beneficiaryApi.reducerPath]: beneficiaryApi.reducer,
  [employeeContributionApi.reducerPath]: employeeContributionApi.reducer,
  [legalDocumentsApi.reducerPath]: legalDocumentsApi.reducer,
});

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat([
      beneficiaryApi.middleware,
      employeeContributionApi.middleware,
      legalDocumentsApi.middleware,
    ]),
});

export type RootState = ReturnType<typeof reducers>;

export type AppDispatch = typeof store.dispatch;
